module.exports = __webpack_public_path__ + "static/media/plus-line-primary.a251371d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/plus-line-primary.svg
// module id = 248
// module chunks = 0